<template>
  <div class="comp-ly-header">
    <jw-card :bordered="false" class="layout-card-header">
      <div class="layout-card-header-top">
        <jw-space>
          <!-- <slot name="tagName">
            <jw-tag color="#f53f3f">销售线索</jw-tag>
            <span :style="{ fontSize: '18px' }">公司名称</span>
          </slot> -->
          <!-- <slot name="extra">
            <jw-tag v-if="data.important?.fieldValue" color="magenta">{{ $t('重点') }}</jw-tag>
          </slot> -->

          <jw-tooltip position="bottom" :content="data.isFullscreen ? $t('退出全屏') : $t('全屏展示')">
            <jw-button @click="toggleFullScreen" class="activeIcon" size="small">
              <template #icon>
                <qfei-icon-full-screen-outlined v-if="!data.isFullscreen" class="icon-size" />
                <qfei-icon-contract-outlined v-else class="icon-size" />
              </template>
            </jw-button>
          </jw-tooltip>

          <slot name="objName">
            <!-- <span>对象名称</span> -->
          </slot>
          <jw-tooltip v-if="computedErrorTooltipContent" :content="computedErrorTooltipContent">
            <icon-loading v-if="props.loading" :size="20" style="color: rgb(var(--primary-6))" spin />
          </jw-tooltip>
          <template v-else>
            <icon-loading v-if="props.loading" :size="20" style="color: rgb(var(--primary-6))" spin />
          </template>
        </jw-space>
        <jw-space>
          <jw-space class="space-small">
            <slot name="button"></slot>
            <jw-tooltip position="bottom" :content="$t('详情页配置')" v-if="showDetailConfig">
              <jw-button @click="openDetailConfig" class="activeIcon" size="small">
                <template #icon>
                  <qfei-icon-column-setting-outlined />
                </template>
              </jw-button>
            </jw-tooltip>
            <span class="divider">|</span>
            <jw-tooltip position="bottom" :content="$t('复制链接')">
              <jw-button @click="copyPageLink" class="activeIcon" size="small">
                <template #icon>
                  <qfei-icon-hyperlink-outlined class="icon-size" />
                </template>
              </jw-button>
            </jw-tooltip>
            <jw-tooltip position="bottom" :content="$t('刷新')">
              <jw-button class="activeIcon" @click="refreshDetail" size="small">
                <template #icon>
                  <qfei-icon-refresh-outlined class="icon-size" />
                </template>
              </jw-button>
            </jw-tooltip>
            <span class="divider">|</span>
            <jw-tooltip position="bottom" :content="$t('关闭')">
              <jw-button @click="handleCancel" class="activeIcon" size="small">
                <template #icon>
                  <qfei-icon-close-one-outlined class="icon-size" />
                </template>
              </jw-button>
            </jw-tooltip>
            <!-- </template> -->
          </jw-space>
        </jw-space>
      </div>
    </jw-card>
  </div>
</template>

<script setup>
import { reactive, inject, computed } from 'vue';
import { usePricesheetStore, useContractStore, useOrderStore } from '@/store';
import { QfeiIconFullScreenOutlined, QfeiIconContractOutlined, QfeiIconHyperlinkOutlined, QfeiIconRefreshOutlined, QfeiIconCloseOneOutlined, QfeiIconColumnSettingOutlined } from '@qfei-design/icons-vue';
import { Message } from '@arco-design/web-vue';
import { getKey } from '@/utils/authkey';
import { objectIndexLinkPre } from '@/utils/const';
import { useI18n } from 'vue-i18n';
import { useUserStore, useEntityGrayStore } from '@/store';

const { t } = useI18n();
const emits = defineEmits(['cb']);
const getPricesheetStore = usePricesheetStore(); //报价单store
const getContract = useContractStore(); //合同store
const getOrderStore = useOrderStore(); //销售订单store
const { userInfo } = useUserStore(); //用户信息
const entityStore = useEntityGrayStore(); // 对象灰度

const props = defineProps({
  tabIndex: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  },
  //视图id，复制详情页链接使用
  viewId: {
    type: Number,
    default: -1
  },
  entity: {
    type: Number,
    default: 0
  },
  computedErrorTooltipContent: {
    type: String,
    default: ''
  }
});
const data = reactive({
  isFullscreen: false, //是否全屏
  id: inject('detailParams')?.id || inject('detailParams')?.id, //id,
  type: inject('detailParams')?.entity, //类型1-线索 2-客户 3-商机 4-产品
  updateType: inject('globalParams')?.type || inject('detailParams')?.type, //类型1-线索 2-客户 3-商机 4-产品
  permission: inject('detailParams')?.permission, //协作人权限
  status: inject('detailParams')?.status //报价单生命状态
});

// 全屏切换
const toggleFullScreen = () => {
  data.isFullscreen = !data.isFullscreen;
  const params = {
    type: 1,
    hp: data.isFullscreen
  };
  emits('cb', params);
};

const objInfo = computed(() => {
  const data = userInfo?.menus?.entityResources?.find((item) => props.entity && item?.entity == props.entity);
  return {
    icon: data?.icon ?? '',
    name: data?.title ?? ''
  };
});

// 详情页快速入口配置
const showDetailConfig = computed(() => {
  return entityStore.entityGray && props.entity != 101 && objInfo?.value.name && userInfo?.roles?.indexOf(props.entity >= 200 ? 'object:custom' : 'object:system') !== -1;
});
//复制页面链接
const copyPageLink = () => {
  const _location = window.location;
  const { key, skey } = getKey();
  let _url = _location.origin;
  let baseUrl = '';
  if (data.type >= 200) {
    baseUrl = `/custom/${data.type}${data.type}`;
  } else {
    if (objectIndexLinkPre?.[data.type]) {
      baseUrl = objectIndexLinkPre?.[data.type];
    } else {
      Message.error(t('请选择对象'));
      return false;
    }
  }
  //将列表路由和打开详情的id拼接进去
  _url += `${baseUrl}/${data.id}?viewId=${props.viewId}&key=${key}&skey=${skey}`;
  try {
    navigator.clipboard.writeText(_url);
    Message.success(t('链接已复制到剪贴板'));
  } catch (e) {
    console.log(e);
    Message.error(t('复制失败'));
  }
};

// 打开详情页配置
const openDetailConfig = () => {
  const params = {
    type: 4,
    hp: props.tabIndex
  };
  emits('cb', params);
};
// 抽屉详情之取消按钮
const handleCancel = () => {
  const priceParams = getPricesheetStore.priceParams;
  const contractParams = getContract.contractParams;
  const orderParams = getOrderStore.orderParams;
  console.log(orderParams);
  if ((priceParams.entity == 2 || priceParams.entity == 3) && getPricesheetStore?.isRefresh) {
    //客户|| 商机
    getList(priceParams);
  } else if ((data.updateType == 2 || data.updateType == 3) && getContract?.isRefresh) {
    getContractList(contractParams);
  } else if ((data.updateType == 2 || data.updateType == 3) && getOrderStore?.isRefresh) {
    getOrderList(orderParams);
  }
  const params = {
    type: 2,
    hp: props.tabIndex
  };
  emits('cb', params);
};
// 刷新详情
const refreshDetail = () => {
  const params = {
    type: 3,
    hp: props.tabIndex
  };
  emits('cb', params);
};
// 根据ID获取报价单列表
const getList = async (params) => {
  await getPricesheetStore
    .getPricesheetLists(params)
    .then((res) => {
      console.log(res);
    })
    .finally(() => {});
};
// 根据ID获取合同列表
const getContractList = async (params) => {
  await getContract
    .getContractLists(params)
    .then((res) => {
      console.log(res);
    })
    .finally((err) => {
      console.log(err);
    });
};
// 根据ID获取订单列表
const getOrderList = async (params) => {
  await getOrderStore
    .getOrderLists(params)
    .then((res) => {
      console.log(res);
    })
    .finally((err) => {
      console.log(err);
    });
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
